export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14726.91d8c595.jpg";